import React from 'react';

import { StyledAccordionActions } from './Accordion.styles';
import type { AccordionActionsProps } from './Accordion.types';

/**
 * Primitive AccordionActions component with responsive padding
 * Footer area for action buttons with container-aware spacing
 */
export const AccordionActions: React.FC<AccordionActionsProps> = ({ children, ...props }) => {
  return <StyledAccordionActions {...props}>{children}</StyledAccordionActions>;
};